<template>
  <div>
    <!-- 提示信息2 -->
    <alertStep :useDefault="false" specialType="2" :specialRentCategory="this.rentDateInfo.rentCategory"/>
    <form-text-box
      ref="rentInfoBox"
      :dataList="rentLeasePlan_formConfig"
      :rules="rentLeasePlan_formRule"
      :model="rentLeasePlan_model"
      :column="4"
    />
    <!-- table -->
    <el-table
      v-loading="tableLoading"
      :data="tableData"
      :span-method="arraySpanMethod"
      max-height="270">
      <el-table-column prop="fundType" label="收款项">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="payMode" label="收款方式">
        <template slot-scope="scope">
          <span v-if="scope.row.isConfirm">{{ scope.row.payMode | enumerationFilter(paymentMethods) }}</span>
          <span class="tipRed" v-else>{{ scope.row.toast | filterToast(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalCycle" label="总期数">
        <template slot-scope="scope">
          <div v-if="scope.row.isConfirm">{{ scope.row.totalCycle }}</div>
          <div v-else>
            <el-button
              @click.native.prevent="startConfigRow(scope.$index, scope.row)"
              type="text"
              size="small">
              点击配置
            </el-button>
            <el-button
              v-if="isDeleteFn(scope.row)"
              @click.native.prevent="deleteRowConfig(scope.$index, scope.row.name)"
              type="text"
              size="small">
              删除
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column  prop="totalAmount" label="收款金额">
        <template slot-scope="scope">
          {{ scope.row.totalAmount | addUnit(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="isConfirm" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.isConfirm"
            @click.native.prevent="modificationRowConfig(scope.row)"
            type="text"
            size="small">
            修改
          </el-button>
          <el-button
            v-if="isDeleteFn(scope.row)"
            @click.native.prevent="deleteRowConfig(scope.$index, scope.row.name)"
            type="text"
            size="small">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- button -->
    <div class="planSetup-setupBox-operation">
      <el-select v-model="addFundType" placeholder="请选择">
        <el-option
          v-for="item in rentOrderFeeFilterList"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="addPaymentPlan" :disabled="this.rentDateInfo.disabled">新增收款项</el-button>
    </div>
    <!-- 支付计划设置 -->
    <PaymentPlanPopup
      :step="planPopupStep"
      v-model="popupShow"
      :configPaymentPlan="configPaymentPlanData"
      :isAddScheme="false"
      :configDisabled="configDisabled"
      @getParams="getParams"
    />
  </div>
</template>
<script>
import { getAccruedPlanStatistic, orderAccruedplanvalidAccruedPlanAmountApi } from '@/api/domain/orders.js'
import PaymentPlanPopup from '@/components/PaymentPlanPopup/index.vue'
import alertStep from '@/components/rentCalculateConfig/alertStep.vue'
import orderConfigFn from '@/pages/orders/config/index.js'
import selectOption from '@/store/dict/selectOptionDict'
import { addition, formatNumberWithCommas } from '@/utils'
import { CATEGORY_FEE_MAP, CATEGORY_CODE_MAP, FEE_CODE_MAP, PAYPOSY_CODE_MAP, ADVANCEPAYMENT_CODE_MAP, PAYMODE_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import { mapState } from 'vuex'
import rentLeasePlanInfoFn from './config/rentLeasePlanInfo.js'
import { isNewOverdue } from '@/pages/utils/overdue'

export default {
  name: 'rentLeasePlanInfo',
  components: {
    alertStep,
    PaymentPlanPopup,
  },
  props: {
    rentDateInfo: { // 包含合同起止时间、租期、赠送天数、类别
      type: Object,
      default: () => ({
        rentCategory: 1, // 类别 - 默认租车
        signDate: '', // 签署日期
        startStopDate: '', // 收款起止日期
        presentDays: '', // 赠送天数
        isTranDeposit: '', // 是否平移原订单押金 1-是 0-否
        contractDateText: '', // 合同起止日期文本 eg: 2023-07-01~2023-07inject-31
        rentPeriodText: '', // 租期文本(天数) eg: 共7天
        presentDaysText: '', // 赠送天数文本 eg: 0天
        disabled: false,
      }),
    },
    defaultTableData: { // 默认支付计划数据
      type: Array,
      default: () => [],
    },
  },
  data() {
    const { m_weekList } = orderConfigFn.call(this)
    const {
      rentLeasePlan_formRule,
      rentLeasePlan_model,
    } = rentLeasePlanInfoFn.call(this)
    return {
      isReady: false,
      m_weekList: this.formatEnumeration(m_weekList),
      selectOption,
      planPopupStep: 1, // 设置支付计划组件步骤
      rentLeasePlan_formRule,
      rentLeasePlan_model,
      addFundType: '',
      tableData: [],
      tableLoading: false,
      rentOrderFeeFilterList: [],
      rentLeasePlan_formConfig: [],
      // 弹窗相关
      configDisabled: false,
      popupShow: false,
      configPaymentPlanData: {
        formData: {},
      },
    }
  },
  filters: {
    // 收款项显示中文
    enumerationFilter(val, list) {
      const name =
        (list && list.find((item) => {
          return Number(item.code) === Number(val)
        })?.name) || ''
      return name
    },
    addUnit(val, rowData) {
      if (isNewOverdue(rowData)) {
        return `未付租金*${rowData.lateFeeProportion}%/日`
      } else if (val === 0 || val) {
        return `${formatNumberWithCommas(val)} 元`
      } else {
        return '--'
      }
    },
    filterToast(val, rowData) {
      const text = `${val}请点击配置${rowData.name}的支付计划`
      return text
    },
  },
  computed: {
    ...mapState({
      paymentMethods: (state) => state.global.paymentMethods, // 收款方式
      orderSignRentFee: (state) => state.rentPlan.orderSignRentFee, // 租车费项
      orderSignPurchaseFee: (state) => state.rentPlan.orderSignPurchaseFee, // 已租代购费项
      orderSignCooperateFee: (state) => state.rentPlan.orderSignCooperateFee, // 司机合作模式费项
    }),
  },
  watch: {
    rentDateInfo: {
      handler(newVal, oldVal) {
        // 还有其他的值未设置
        if (newVal.rentCategory) {
          this.rentLeasePlan_model.rentCategory = newVal.rentCategory
          this.$emit('rentCategoryType', newVal.rentCategory)
        }
        if (!oldVal || oldVal?.rentCategory !== newVal.rentCategory) {
          // ① 请求费项list
          this.queryFeeList()
          // ② 配置 $rentInfoBox 配置项
          this.configRentInfoBox()
        }
        this.rentLeasePlan_model.contractDateText = newVal.contractDateText
        this.rentLeasePlan_model.rentPeriodText = newVal.rentPeriodText
        this.rentLeasePlan_model.presentDaysText = newVal.presentDaysText || '0天'
      },
      immediate: true,
      deep: true,
    },
    defaultTableData: {
      handler(val) {
        if (val.length) {
          this.tableData = JSON.parse(JSON.stringify(val))
          this.tableData.forEach((item) => {
            item.isPayPostCustom = item.payPost === PAYPOSY_CODE_MAP.CUSTOM
          })
        }
      },
      immediate: true,
      deep: true,
    },
    tableData: {
      handler() {
        // 配置$rentInfoBox的值（订单总计金额、押金、租金、其余收款项 等）
        this.$nextTick(() => {
          this.configRentInfoBoxValue()
        })
        if (this.rentLeasePlan_model.rentCategory === 2) { // 类别为【以租代购】
          // ① 配置费项list
          this.queryFeeList()
          // ② 配置 $rentInfoBox 配置项 - 只做展示项的增减，值变更不在此处处理
          this.configRentInfoBox()
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() { // 获取收款方式（年付，月付，周付等）
      this.$store.dispatch('getPaymentMethods', { type: 'payMode' }).then(() => {
        this.isReady = true
      })
    },
    // 合并列
    arraySpanMethod({ row, columnIndex }) {
      if (row.isConfirm === false) {
        if ([0, 2, 4].includes(columnIndex)) {
          return [1, 1]
        } else if (columnIndex === 1) {
          return [1, 3]
        } else if (columnIndex === 3) {
          return [0, 0]
        }
      }
    },
    // 配置新增费项list
    queryFeeList() {
      if (!this.rentDateInfo.rentCategory) {
        return
      }
      this.tableLoading = true
      const someFeeList = this[CATEGORY_FEE_MAP[Number(this.rentDateInfo.rentCategory)]]
      if (!someFeeList || !someFeeList.length) {
        // 根据【类别】获取不同类别对应的费项
        this.$store.dispatch('getFeeList', { type: CATEGORY_FEE_MAP[Number(this.rentDateInfo.rentCategory)] }).then((res) => {
          this.tableLoading = false
          this.setSelectList(res.data)
        }).catch(() => {
          this.tableLoading = false
          this.$set(this, 'rentOrderFeeFilterList', [])
        })
      } else {
        this.tableLoading = false
        this.setSelectList(someFeeList)
      }
    },
    // 设置新增收款项list
    setSelectList(feeList) {
      if (Number(this.rentLeasePlan_model.rentCategory) !== CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) { // 类别为【租车】和【司机合作模式】，新增费项的list为过滤掉必填项
        this.$set(this, 'rentOrderFeeFilterList', feeList.filter((it) => !it.required))
      } else { // 类别为【以租代购】
        // 新增费项的list为过滤掉table中已经有的费项（首付款, 租金, 全款）
        const filterFeeCodes = [FEE_CODE_MAP.SHOU_FU_KUAN, FEE_CODE_MAP.ZU_JIN, FEE_CODE_MAP.QUAN_KUAN] // 首付款, 租金, 全款
        filterFeeCodes.forEach((feeCode) => {
          if (this.tableData.some((i) => Number(i.fundType) === feeCode)) {
            feeList = feeList.filter((it) => Number(it.code) !== feeCode)
          }
        })
        this.$set(this, 'rentOrderFeeFilterList', feeList)
      }
    },
    // 配置 $rentInfoBox 配置项
    configRentInfoBox() {
      let configData = rentLeasePlanInfoFn.call(this).rentLeasePlan_origin_formConfig
      let configDataCp = JSON.parse(JSON.stringify(configData))
      const showFlag = this.rentLeasePlan_model.rentCategory
      if (!showFlag) {
        console.error('未设置类别，请检查rentLeasePlan_model对象中的category是否有值')
      }
      configData = configData.filter((i) => i.showItem.includes(Number(showFlag)))
      const filterFeeNames = ['首付款', '租金', '全款']

      if (Number(this.rentLeasePlan_model.rentCategory) === 2) {
        filterFeeNames.forEach((name) => {
          if (!this.tableData.some((i) => i.name === name)) {
            configDataCp.forEach((item) => {
              if (item.itemName === name && item.showItem.includes(2)) {
                const idx = item.showItem.findIndex((i) => i === 2)
                item.showItem.splice(idx, 1)
              }
            })
          }
        })
        configDataCp = configDataCp.filter((i) => i.showItem.includes(2))
        configData = configDataCp
      }
      // 重新排版
      this.$nextTick(() => {
        if (this.$refs.rentInfoBox) {
          this.$refs.rentInfoBox.autoColumn()
        }
      })
      this.rentLeasePlan_formConfig = configData
    },
    // 配置$rentInfoBox的值（订单总计金额、押金、租金、其余收款项 等）
    configRentInfoBoxValue() {
      // 金额展示逻辑，如果没有配置，则展示 '--'
      // ① 总金额
      if (this.tableData.every((i) => i.isConfirm === false)) {
        this.rentLeasePlan_model.allTotalAmount = '--'
      } else {
        const allTotalAmount = this.tableData.reduce((sum, item) => {
          if (item.totalAmount) {
            sum = addition(sum, item.totalAmount)
          }
          return sum
        }, 0)
        this.rentLeasePlan_model.allTotalAmount = `${formatNumberWithCommas(allTotalAmount)} 元`
      }
      // ② (押金、租金)或(首付款)，其余收款项
      const depositFeeData = this.tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.YA_JIN) // 2-押金
      if (depositFeeData) {
        this.rentLeasePlan_model.deposit = depositFeeData.isConfirm ? `${formatNumberWithCommas(depositFeeData?.totalAmount || 0)} 元` : '--'
      }
      const rentAmountFeeData = this.tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.ZU_JIN) // 1-租金
      if (rentAmountFeeData) {
        this.rentLeasePlan_model.rentAmount = rentAmountFeeData.isConfirm ? `${formatNumberWithCommas(rentAmountFeeData?.totalAmount || 0)} 元` : '--'
      }
      const firstPaymentFeeData = this.tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN) // 24-首付款
      if (firstPaymentFeeData) {
        this.rentLeasePlan_model.firstPayment = firstPaymentFeeData.isConfirm ? `${formatNumberWithCommas(firstPaymentFeeData?.totalAmount || 0)} 元` : '--'
      }
      const fullPaymentFeeData = this.tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN) // 15-全款
      if (fullPaymentFeeData) {
        this.rentLeasePlan_model.fullPayment = fullPaymentFeeData.isConfirm ? `${formatNumberWithCommas(fullPaymentFeeData?.totalAmount || 0)} 元` : '--'
      }
      // 其余收款项
      const otherTableFeeList = this.tableData.filter((item) => { // 1-租金 2-押金 15-全款 24-首付款
        return (Number(item.fundType) !== FEE_CODE_MAP.ZU_JIN &&
          Number(item.fundType) !== FEE_CODE_MAP.YA_JIN &&
          Number(item.fundType) !== FEE_CODE_MAP.QUAN_KUAN &&
          Number(item.fundType) !== FEE_CODE_MAP.SHOU_FU_KUAN)
      })
      if (otherTableFeeList.every((i) => i.isConfirm === false)) {
        this.rentLeasePlan_model.otherAmount = '--'
      } else {
        const otherTableFeeTotalAmount = otherTableFeeList.reduce((sum, item) => {
          sum = addition(sum, item?.totalAmount || 0)
          return sum
        }, 0)
        this.rentLeasePlan_model.otherAmount = `${formatNumberWithCommas(otherTableFeeTotalAmount)} 元`
      }
    },
    // 已添加的是否可删除 - 【以租代购】互斥逻辑
    isDeleteFn(rowData) {
      if (this.rentLeasePlan_model.rentCategory !== CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) { // 除类别为 【已租代购】，其他类别添加的收款项中，非必填字段可删除
        return (!rowData.required && !rowData.isSelectScheme)
      } else if (Number(rowData.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN) { // 24-首付款
        return (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN)) && !rowData.isSelectScheme // 15-全款
      } else if (Number(rowData.fundType) === FEE_CODE_MAP.ZU_JIN) { // 1-租金
        return (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN)) && !rowData.isSelectScheme // 15-全款
      } else if (Number(rowData.fundType) === FEE_CODE_MAP.QUAN_KUAN) { // 15-全款
        return (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN || Number(i.fundType) === FEE_CODE_MAP.ZU_JIN) && !rowData.isSelectScheme)
      } else {
        return (!rowData.required && !rowData.isSelectScheme)
      }
    },
    // 点击配置
    startConfigRow($index, rowData) {
      const nextFlag = this.beforeValid('add')
      if (!nextFlag) return
      this.planPopupStep = 1
      const formData = {
        ...rowData,
        startTime: this.rentDateInfo.startStopDate[0],
        endTime: this.rentDateInfo.startStopDate[1],
      }
      if (rowData.isSelectScheme) {
        this.configDisabled = true
      } else {
        this.configDisabled = false
      }
      this.configPaymentPlanData.formData = formData
      this.popupShow = true
    },
    // 新增收款项
    addPaymentPlan() {
      // 新增收款项之前的校验
      const nextFlag = this.beforeValid('add')
      if (!nextFlag) return
      if (!this.addFundType) return
      this.configDisabled = false
      this.planPopupStep = 1
      const hasSomeFundType = this.tableData.find((i) => Number(i.fundType) === Number(this.addFundType))
      if (hasSomeFundType) {
        this.$message.error(`收款项“${hasSomeFundType.name}”已在支付计划中，请勿重复添加`)
        return
      }
      const formData = {
        fundType: Number(this.addFundType),
        startTime: this.rentDateInfo.startStopDate[0],
        endTime: this.rentDateInfo.startStopDate[1],
      }
      // 如果新增的是滞纳金，则将滞纳金标识设置为1，代表新的滞纳金
      if (this.addFundType === FEE_CODE_MAP.ZHI_NA_JIN) {
        formData.lateFeeOpen = 1
      }
      this.configPaymentPlanData.formData = formData
      this.popupShow = true
      this.addFundType = null // 添加完后置空
    },
    // 修改配置
    modificationRowConfig(rowData) {
      const nextFlag = this.beforeValid('edit')
      if (!nextFlag) return
      // 新滞纳金 planPopupStep设置为1，因为没有上一步下一步step操作
      this.planPopupStep = isNewOverdue(rowData) ? 1 : 2
      const modifiedFeeItem = this.tableData.some((i) => Number(i.fundType) === Number(rowData.fundType))
      if (!modifiedFeeItem) {
        console.error('未在table数据中找到修改费项，请检查tableData数据是否正常')
        return false
      }
      if (rowData.isSelectScheme) {
        this.configDisabled = true
      } else {
        this.configDisabled = false
      }
      this.configPaymentPlanData.formData = {
        ...rowData,
        receivableTotalAmount: rowData.receivableTotalAmount || '',
        startTime: this.rentDateInfo.startStopDate[0] || '',
        endTime: this.rentDateInfo.startStopDate[1] || '',
        amount: rowData.planAmount || '',
      }
      this.configPaymentPlanData.tableData = rowData.items
      this.popupShow = true
    },
    // 删除配置
    deleteRowConfig($index, feeName) {
      this.$confirm(`收款项${feeName}及相关款项配置将从支付计划中删除，确定?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.tableData.splice($index, 1)
      }).catch(() => null)
    },
    // 新增收款项或配置支付计划之前的校验
    beforeValid(messageFlag) {
      const messageMap = {
        add: '需要根据“收款起止日期”进行各款项周期的应收拆分，请先填写后再确认支付计划',
        edit: '需要根据“收款起止日期”进行各款项周期的应收拆分，请先填写后再确认支付计划',
      }
      if (!this.rentDateInfo.startStopDate || !this.rentDateInfo.startStopDate.length) {
        this.$message.error(messageMap[messageFlag])
        // ~~~~~~ 此时需要锚点到收款起止日期的位置上去
        this.$emit('autoAnchor', false)
        return false
      } else {
        return true
      }
    },
    // 表单校验，若通过校验，返回table数据，若未通过，返回false
    getFormData() {
      // 表格部分的收费项校验
      const requiredValidRes = this.validRequiredFee()
      if (!requiredValidRes) {
        this.$message.error('费项配置无必填项！请检查')
        return false
      }
      if (this.rentDateInfo.rentCategory === CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) { // 类别为以租代购
        // 如果有「全款」费项，校验 是否有「首付款」或「租金」或「尾款」，如果有则阻断提交
        if (this.tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN)) { // 15-全款
          if (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN || Number(i.fundType) === FEE_CODE_MAP.ZU_JIN || Number(i.fundType) === FEE_CODE_MAP.WEI_KUAN)) { // 24-首付款 1-租金 25-尾款
            this.$message.error('签约时，全款 和 首付款/租金/尾款 不能同时收取，请检查修复后重新提交')
            return false
          }
        } else if (!this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN) || !this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.ZU_JIN)) { // 1-租金 24-首付款
          // 1-租金 24-首付款
          // 如果没有「全款」，校验 「首付款」和「租金」 为必填项，都必须填全
          this.$message.error('首付款和租金为必填项，都必须填全')
          return false
        }
      }
      // 先校验必填费项是否配置完成
      const noConfigRequiredFeeNames = this.tableData.reduce((total, item) => {
        if (item.required && !item.isConfirm) {
          total = total.concat([item.name])
        }
        return total
      }, [])
      if (noConfigRequiredFeeNames.length > 0) {
        this.$message.error(`${noConfigRequiredFeeNames.toString().replaceAll(',', '、')}为必须的收款项，请先配置`)
        return false
      }
      // 添加的费项都配置完成才能返回true
      const tableDataHasNoConfig = this.tableData.some((i) => i.isConfirm === false)
      if (tableDataHasNoConfig) {
        const noConfigFeeNames = this.tableData.reduce((total, item) => {
          if (!item.isConfirm) {
            total = total.concat([item.name])
          }
          return total
        }, [])
        this.$message.error(`请将${noConfigFeeNames.toString().replaceAll(',', '、')}配置完成`)
        return false
      }
      return this.tableData
    },
    // 校验必填费项
    validRequiredFee() {
      if (!this.tableData.length) {
        return false
      } else if (!this.tableData.some((i) => i.required)) {
        return false
      } else {
        return true
      }
    },
    disposeOverdueRowData(item) {
      // 发车前收款 为 发车前不收
      item.advancePayment = ADVANCEPAYMENT_CODE_MAP.NOT_ACCEPT
      // 收款方式 为 一次性
      item.payMode = PAYMODE_CODE_MAP.DISPOSABLE
      item.lastPeriodRule = null
      item.payDate = null
      item.payDay = null
      item.payPost = null
    },
    // 点击弹窗的确定，获取配置的表单
    async getParams(value) {
      this.tableLoading = true
      // 获取支付计划汇总数据
      const res = await getAccruedPlanStatistic({ accruedPlanList: value.items }).catch(() => {
        console.error('获取汇总数据失败，请重新配置')
        this.tableLoading = false
        return false
      })
      this.tableLoading = false
      if (res.code === 1) {
        value.formData.totalCycle = res.data?.totalCycle // 总期数
        value.formData.totalAmount = res.data?.totalAmount // 计算得到的总金额
      }
      if (this.tableData.some((i) => Number(i.fundType) === Number(value.formData.fundType))) { // 费项列表中已添加
        const newTableData = this.tableData.map((each) => {
          if (Number(each.fundType) === Number(value.formData.fundType)) {
            const nite = Object.assign({}, each, value.formData)
            nite.isConfirm = true
            nite.items = value?.items
            // nite.totalCycle = value?.items?.length
            nite.planAmount = value.formData.amount // 兼容【创建订单】逻辑~~~~~，待服务端修改
            // 如果是新滞纳金 收款金额列展示 费率 发车前收款展示 发车前不收 尾期租金规则 null (修改时)
            if (isNewOverdue(value.formData)) {
              this.disposeOverdueRowData(nite)
            }
            return nite
          } else {
            return each
          }
        })
        this.$set(this, 'tableData', newTableData)
      } else { // 费项列表中未添加
        const fee = this[CATEGORY_FEE_MAP[this.rentLeasePlan_model.rentCategory]].find((i) => Number(i.code) === Number(value.formData.fundType))
        const addFeeItem = {
          ...value.formData,
          planAmount: value.formData.amount, // 金额
          fundType: fee.code, // 费项code
          name: fee.name, // 费项名
          required: fee.required, // 是否必填 boolean
          toast: fee.toast, // 费项 toast
          items: value.items, // 费项支付计划
        }
        addFeeItem.isConfirm = true
        // 如果是新滞纳金 收款金额列展示 费率 发车前收款展示 发车前不收 尾期租金规则 null (添加时)
        if (isNewOverdue(value.formData)) {
          this.disposeOverdueRowData(addFeeItem)
        }
        this.tableData.push(addFeeItem)
      }
    },
    orderAccruedplanvalidAccruedPlanAmount(accruedPlanParamList) {
      return orderAccruedplanvalidAccruedPlanAmountApi({
        accruedPlanParamList,
        rentCategory: this.rentLeasePlan_model.rentCategory })
    },
  },
}
</script>
<style lang="scss" scoped>
.planSetup-setupBox-operation {
  margin-top: 20px;
  margin-bottom: 20px;
}
.tipRed{
  color: #FF5964;
}
</style>
